"use client"

import Script from "next/script"
import { isPostHogTelemetryEnabled } from "@/shared/lib/monitoring/telemetry-config"

/**
 * Affiliate attribution loader.
 *
 * 1. Sets up Trackdesk command queue + fires "click" event
 * 2. Loads SDK from same-origin proxy (/assets/td) to bypass ad blockers
 * 3. After SDK processes, reads trakdesk_cid cookie (set by SDK) to extract the cid
 * 4. Registers cid as a PostHog super property (sent with every event)
 *
 * Trackdesk direct links use ?linkId=...&sourceId=...&tenantId=pleasurai
 * The SDK reads those params and generates the click ID internally,
 * storing it in the trakdesk_cid cookie as JSON: {"tenantId":"pleasurai","cid":"..."}
 * We read directly from that cookie — no duplicate cookie needed.
 */
export function AffiliateAttributionScript() {
  const postHogTelemetryEnabled = isPostHogTelemetryEnabled()

  return (
    <Script
      id="trackdesk-init"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
(function(t,d,k){
  (t[k]=t[k]||[]).push(d);
  t[d]=t[d]||t[k].f||function(){
    (t[d].q=t[d].q||[]).push(arguments)
  }
})(window,"trackdesk","TrackdeskObject");
trackdesk("pleasurai","click");

(function(){
  function getCidFromTrackdesk(){
    var m=document.cookie.match(/(?:^|;\\s*)trakdesk_cid=([^;]*)/);
    if(!m) return null;
    try{
      var parsed=JSON.parse(decodeURIComponent(m[1]));
      return parsed&&parsed.cid?parsed.cid:null;
    }catch(e){return null;}
  }

  function regPostHog(cid){
    if(${postHogTelemetryEnabled}&&window.posthog&&typeof window.posthog.register==="function"){
      window.posthog.register({trakdesk_cid:cid});
    }
  }

  function sync(){
    var cid=getCidFromTrackdesk();
    if(cid) regPostHog(cid);
  }

  sync();

  var s=document.createElement("script");
  s.async=true;
  s.src="/assets/td";
  s.onload=function(){
    setTimeout(sync,500);
    setTimeout(sync,2000);
  };
  document.head.appendChild(s);
})();`,
      }}
    />
  )
}
